import {
  RecurrenceRuleFrequency,
  RecurrenceRuleRecurringDay
} from "core/gateways/practice/recurrence.dtos";

export class ExclusionPeriodConst {
  public static RecurringDays: RecurrenceRuleRecurringDay[] = [
    RecurrenceRuleRecurringDay.Monday,
    RecurrenceRuleRecurringDay.Tuesday,
    RecurrenceRuleRecurringDay.Wednesday,
    RecurrenceRuleRecurringDay.Thursday,
    RecurrenceRuleRecurringDay.Friday,
    RecurrenceRuleRecurringDay.Saturday,
    RecurrenceRuleRecurringDay.Sunday
  ];

  public static RecurringFrequencies: RecurrenceRuleFrequency[] = [
    RecurrenceRuleFrequency.Daily,
    RecurrenceRuleFrequency.Weekly
  ];
}
